import { Microchip } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const MicrochipIcon = createLucideIcon(Microchip);
